// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1TI4W","innerWrapper":"styles_innerWrapper__1OjGW","row":"styles_row__2i-v0"};